var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comparar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Ficha",
    transform: "translate(-1618.000000, -268.000000)",
    stroke: "",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(1619.500000, 269.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comparar",
    transform: "translate(8.000000, 8.500000) rotate(-270.000000) translate(-8.000000, -8.500000) translate(-0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41666667,5.09090909 L1.41666667,3.63636364 C1.41666667,1.45454545 2.83333333,0 4.95833333,0 L12.0416667,0 C14.1666667,0 15.5833333,1.45454545 15.5833333,3.63636364 L15.5833333,5.09090909",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41666667,10.9090909 L1.41666667,12.3636364 C1.41666667,14.5454545 2.83333333,16 4.95833333,16 L12.0416667,16 C14.1666667,16 15.5833333,14.5454545 15.5833333,12.3636364 L15.5833333,10.9090909",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 17,
    y2: 8,
    id: "Vector"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparar);
export default __webpack_public_path__ + "static/media/comparar.aea7c140f3ffe43ad41da487a0d7b6b8.svg";
export { ForwardRef as ReactComponent };